import { jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import { typographyClassName } from "@creditornot/cb-ingredients";
import { Tooltip } from "@creditornot/cb-popover";
import { clsx } from "@creditornot/cb-utils";
import { forwardRef } from "react";
import "./style.css";
const HelpCircleFilled = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm0 19a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm1.6-6.08a1 1 0 00-.6.917 1 1 0 01-2 0 3 3 0 011.8-2.75A2 2 0 1010 9.255a1 1 0 11-2 0 4 4 0 115.6 3.666v-.001z" }) }));
const InfoCircleFilled = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm.25 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75c0 .138.112.25.25.25h.75a1 1 0 010 2z" }) }));
const responsiveContainerClassName = "cb_styleUtils_responsiveContainer_rl03";
const Root$3 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_FormRow_Root_rfm6",
  propsAsIs: false
});
const _exp2$2 = () => ({
  $labelAlign
}) => $labelAlign.startsWith("top") ? "flex-start" : "center";
const _exp3$1 = () => ({
  $labelAlign
}) => $labelAlign === "top-pad" ? "8px" : "0";
const LeftCol$2 = /* @__PURE__ */ styled("div")({
  name: "LeftCol",
  class: "cb_FormRow_LeftCol_ll21",
  propsAsIs: false,
  vars: {
    "ll21550-0": [_exp2$2()],
    "ll21550-1": [_exp3$1()]
  }
});
const RightCol$2 = /* @__PURE__ */ styled("div")({
  name: "RightCol",
  class: "cb_FormRow_RightCol_r1b7",
  propsAsIs: false
});
const _exp4 = () => ({
  $labelContentAlign
}) => $labelContentAlign === "top" ? "flex-start" : "center";
const LabelContainer = /* @__PURE__ */ styled("div")({
  name: "LabelContainer",
  class: "cb_FormRow_LabelContainer_l1tz",
  propsAsIs: false,
  vars: {
    "l1tzypza-0": [_exp4()]
  }
});
const Label$1 = /* @__PURE__ */ styled("label")({
  name: "Label",
  class: "cb_FormRow_Label_lejs",
  propsAsIs: false
});
const Asterisk$1 = /* @__PURE__ */ styled("span")({
  name: "Asterisk",
  class: "cb_FormRow_Asterisk_a1m8",
  propsAsIs: false
});
const InfoContainer = /* @__PURE__ */ styled("div")({
  name: "InfoContainer",
  class: "cb_FormRow_InfoContainer_inxj",
  propsAsIs: false
});
const _exp7 = () => InfoCircleFilled;
const InfoIcon = /* @__PURE__ */ styled(_exp7())({
  name: "InfoIcon",
  class: "cb_FormRow_InfoIcon_ifr6",
  propsAsIs: true
});
const LeftColContent = /* @__PURE__ */ styled("div")({
  name: "LeftColContent",
  class: "cb_FormRow_LeftColContent_l13a",
  propsAsIs: false
});
const FormRow = ({
  children,
  className,
  horizontalPadding = false,
  info,
  label,
  labelAlign = "top",
  labelContentAlign = "center",
  labelHtmlFor,
  leftColContent,
  leftColStyle,
  required,
  rightColStyle,
  style
}) => /* @__PURE__ */ jsxs(Root$3, {
  className: clsx(className, typographyClassName.Body3, horizontalPadding && responsiveContainerClassName),
  style,
  children: [/* @__PURE__ */ jsxs(LeftCol$2, {
    $labelAlign: labelAlign,
    style: leftColStyle,
    children: [/* @__PURE__ */ jsxs(LabelContainer, {
      $labelContentAlign: labelContentAlign,
      children: [/* @__PURE__ */ jsxs(Label$1, {
        htmlFor: labelHtmlFor,
        children: [label, required && /* @__PURE__ */ jsx(Asterisk$1, {
          children: " *"
        })]
      }), !!info && /* @__PURE__ */ jsx(Tooltip, {
        content: info,
        children: /* @__PURE__ */ jsx(InfoContainer, {
          children: /* @__PURE__ */ jsx(InfoIcon, {})
        })
      })]
    }), leftColContent !== void 0 && leftColContent !== null && /* @__PURE__ */ jsx(LeftColContent, {
      children: leftColContent
    })]
  }), /* @__PURE__ */ jsx(RightCol$2, {
    style: rightColStyle,
    children
  })]
});
const FormRow$1 = FormRow;
const Root$2 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_FormHeader_Root_r1jv",
  propsAsIs: false
});
const LeftCol$1 = /* @__PURE__ */ styled("div")({
  name: "LeftCol",
  class: "cb_FormHeader_LeftCol_l1ur",
  propsAsIs: false
});
const RightCol$1 = /* @__PURE__ */ styled("div")({
  name: "RightCol",
  class: "cb_FormHeader_RightCol_rjwn",
  propsAsIs: false
});
const RightContentContainer = /* @__PURE__ */ styled("div")({
  name: "RightContentContainer",
  class: "cb_FormHeader_RightContentContainer_r4w2",
  propsAsIs: false
});
const Heading = /* @__PURE__ */ styled("h3")({
  name: "Heading",
  class: "cb_FormHeader_Heading_h12c",
  propsAsIs: false
});
const FormHeader = ({
  children,
  className,
  headingElement = "h3",
  horizontalPadding = false,
  rightContent,
  style
}) => /* @__PURE__ */ jsxs(Root$2, {
  className: clsx(className, horizontalPadding && responsiveContainerClassName),
  style,
  children: [/* @__PURE__ */ jsx(LeftCol$1, {
    children: /* @__PURE__ */ jsx(Heading, {
      as: headingElement,
      className: typographyClassName.Title1,
      children
    })
  }), /* @__PURE__ */ jsx(RightCol$1, {
    className: typographyClassName.Body3,
    children: /* @__PURE__ */ jsx(RightContentContainer, {
      children: rightContent
    })
  })]
});
const FormHeader$1 = FormHeader;
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_InputContainerInfoAlert_Root_r1rz",
  propsAsIs: false
});
const Col = /* @__PURE__ */ styled("div")({
  name: "Col",
  class: "cb_InputContainerInfoAlert_Col_c129",
  propsAsIs: false
});
const _exp = () => Col;
const LeftCol = /* @__PURE__ */ styled(_exp())({
  name: "LeftCol",
  class: "cb_InputContainerInfoAlert_LeftCol_lhw9",
  propsAsIs: true
});
const _exp2$1 = () => Col;
const RightCol = /* @__PURE__ */ styled(_exp2$1())({
  name: "RightCol",
  class: "cb_InputContainerInfoAlert_RightCol_r1ph",
  propsAsIs: true
});
const IconContainer = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_InputContainerInfoAlert_IconContainer_idqt",
  propsAsIs: false
});
const Message = /* @__PURE__ */ styled("div")({
  name: "Message",
  class: "cb_InputContainerInfoAlert_Message_m10u",
  propsAsIs: false
});
const _exp3 = () => InfoCircleFilled;
const StyledInfoCircleFilledIcon = /* @__PURE__ */ styled(_exp3())({
  name: "StyledInfoCircleFilledIcon",
  class: "cb_InputContainerInfoAlert_StyledInfoCircleFilledIcon_sm8w",
  propsAsIs: true
});
const InputContainerInfoAlert = ({
  children,
  className,
  style
}) => /* @__PURE__ */ jsxs(Root$1, {
  className,
  style,
  children: [/* @__PURE__ */ jsx(LeftCol, {
    children: /* @__PURE__ */ jsx(IconContainer, {
      children: /* @__PURE__ */ jsx(StyledInfoCircleFilledIcon, {})
    })
  }), /* @__PURE__ */ jsx(RightCol, {
    children: /* @__PURE__ */ jsx(Message, {
      className: typographyClassName.Small,
      children
    })
  })]
});
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_InputContainer_Root_r5qo",
  propsAsIs: false
});
const LabelRow = /* @__PURE__ */ styled("div")({
  name: "LabelRow",
  class: "cb_InputContainer_LabelRow_l1mj",
  propsAsIs: false
});
const Label = /* @__PURE__ */ styled("label")({
  name: "Label",
  class: "cb_InputContainer_Label_l1is",
  propsAsIs: false
});
const DescriptionPopoverContainer = /* @__PURE__ */ styled("div")({
  name: "DescriptionPopoverContainer",
  class: "cb_InputContainer_DescriptionPopoverContainer_difr",
  propsAsIs: false
});
const _exp2 = () => HelpCircleFilled;
const DescriptionTooltipIcon = /* @__PURE__ */ styled(_exp2())({
  name: "DescriptionTooltipIcon",
  class: "cb_InputContainer_DescriptionTooltipIcon_dbaw",
  propsAsIs: true
});
const ContentRow = /* @__PURE__ */ styled("div")({
  name: "ContentRow",
  class: "cb_InputContainer_ContentRow_cqzz",
  propsAsIs: false
});
const HintRow = /* @__PURE__ */ styled("div")({
  name: "HintRow",
  class: "cb_InputContainer_HintRow_h1ye",
  propsAsIs: false
});
const HintRowLeftCol = /* @__PURE__ */ styled("div")({
  name: "HintRowLeftCol",
  class: "cb_InputContainer_HintRowLeftCol_h1jb",
  propsAsIs: false
});
const HintRowRightCol = /* @__PURE__ */ styled("div")({
  name: "HintRowRightCol",
  class: "cb_InputContainer_HintRowRightCol_h18q",
  propsAsIs: false
});
const CharacterCount = /* @__PURE__ */ styled("div")({
  name: "CharacterCount",
  class: "cb_InputContainer_CharacterCount_cct0",
  propsAsIs: false
});
const Asterisk = /* @__PURE__ */ styled("span")({
  name: "Asterisk",
  class: "cb_InputContainer_Asterisk_afez",
  propsAsIs: false
});
const InputContainer = ({
  characterCount,
  children,
  className,
  description,
  hint,
  label,
  labelHtmlFor,
  required,
  style
}) => /* @__PURE__ */ jsxs(Root, {
  className,
  style,
  children: [(!!label || !!description) && /* @__PURE__ */ jsxs(LabelRow, {
    children: [/* @__PURE__ */ jsxs(Label, {
      className: typographyClassName.Body3,
      htmlFor: labelHtmlFor,
      children: [label, required && /* @__PURE__ */ jsx(Asterisk, {
        children: " *"
      })]
    }), !!description && /* @__PURE__ */ jsx(DescriptionPopoverContainer, {
      children: /* @__PURE__ */ jsx(Tooltip, {
        content: description,
        children: /* @__PURE__ */ jsx(DescriptionTooltipIcon, {})
      })
    })]
  }), /* @__PURE__ */ jsx(ContentRow, {
    children
  }), (!!hint || !!characterCount) && /* @__PURE__ */ jsxs(HintRow, {
    children: [/* @__PURE__ */ jsx(HintRowLeftCol, {
      children: !!hint && /* @__PURE__ */ jsx(InputContainerInfoAlert, {
        children: hint
      })
    }), /* @__PURE__ */ jsx(HintRowRightCol, {
      children: !!characterCount && /* @__PURE__ */ jsx(CharacterCount, {
        className: typographyClassName.Small,
        children: `${characterCount.value} / ${characterCount.max}`
      })
    })]
  })]
});
const InputContainer$1 = InputContainer;
export {
  FormHeader$1 as FormHeader,
  FormRow$1 as FormRow,
  InputContainer$1 as InputContainer
};
//# sourceMappingURL=index.js.map
